import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { accountDetailsKYC, fetchAccountDetails } from "./cl_AccountDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

const AccountDetails = () => {
    const dispatch = useDispatch();
    const [accountDetails, setAccountDetails] = useState({});
    const [detailsUpdatedSuccess, setDetailsUpdatedSuccess] = useState(false);
    const { accountDetailsData } = useSelector((state) => state?.accountDetails);
    const [idProof, setIdProof] = useState({
        type: "",
        idNumber: "",
        idProofFile: ""
    });
    const [addressProof, setAddressProof] = useState({
        type: "",
        idProofFile: ""
    });
    const [idTypeError, setIdTypeError] = useState("");
    const [idNumberError, setIdNumberError] = useState("");
    const [fileError, setFileError] = useState("");
    const [addressTypeError, setAddressTypeError] = useState("");
    const [addressFileError, setAddressFileError] = useState("");
    const [firstNameError, setFirstNameError] = useState('');
    const [middleNameError, setMiddleNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [EmailError, setEmailError] = useState('');
    const [mobileError, setMobileError] = useState('');

    const [dobError, setDobError] = useState('');
    const [countryError, setCountryError] = useState('');
    const [cityError, setCityError] = useState('');
    const [addressError, setAddressError] = useState('');

    const regExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const token = getFromLocalStorage("gk");

    useEffect(() => {
        dispatch(fetchAccountDetails(token));
    }, []);

    useEffect(() => {
        setAccountDetails({
            ...accountDetails,
            firstName: accountDetailsData?.firstName,
            middleName: accountDetailsData?.surName,
            lastName: accountDetailsData?.lastName,
            email: accountDetailsData?.userOtherInfo?.email,
            mobile: accountDetailsData?.userOtherInfo?.phone,
            dateOfBirth: accountDetailsData?.dob,
            country: accountDetailsData?.userOtherInfo?.country,
            city: accountDetailsData?.userOtherInfo?.city,
            address: accountDetailsData?.userOtherInfo?.address
        });
    }, [accountDetailsData]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setAccountDetails({ ...accountDetails, [name]: value });

        setFirstNameError("");
        setMiddleNameError("");
        setLastNameError("");
        setEmailError("");
        setMobileError("");
        setDobError("");
        setCountryError("");
        setCityError("");
        setAddressError("");
    };

    const handleUpdateDetails = () => {
        if (accountDetails.firstName == null) {
            setFirstNameError("Enter first name");
        } else if (accountDetails.middleName == null) {
            setMiddleNameError("Enter middle name");
        } else if (accountDetails.lastName == null) {
            setLastNameError("Enter last name");
        } else if (accountDetails.email == "") {
            setEmailError("Enter Email ID");
        } else if (!regExp.test(accountDetails.email)) {
            setEmailError("Invalid Email ID");
        } else if (accountDetails.mobile == "") {
            setMobileError("Enter mobile number");
        } else if (accountDetails.dateOfBirth === null) {
            setDobError("Enter Date of Birth");
        } else if (accountDetails.country === null) {
            setCountryError("Enter Country");
        } else if (accountDetails.city === null) {
            setCityError("Enter City");
        } else if (accountDetails.address === null) {
            setAddressError("Enter Address");
        } else {
            setDetailsUpdatedSuccess(true);
            setTimeout(() => setDetailsUpdatedSuccess(false), 2000)
        }
    };

    const handleIdProof = (e) => {
        setIdTypeError("");
        setIdNumberError("");
        setFileError("");

        const { value, name, files } = e.target;
        setIdProof({ ...idProof, [name]: value });

        if (name === "idProofFile") {
            setIdProof({ ...idProof, [name]: URL.createObjectURL(files[0]) });
        }
    };

    const handleAddressProof = (e) => {
        setAddressTypeError("");
        setAddressFileError("");

        const { value, name, files } = e.target;
        setAddressProof({ ...addressProof, [name]: value });

        if (name === "idProofFile") {
            setAddressProof({ ...addressProof, [name]: URL.createObjectURL(files[0]) });
        }
    };

    const uploadIdProof = () => {
        if (idProof.type === "") {
            setIdTypeError("Select any id proof");
        } else if (idProof.idNumber === "") {
            setIdNumberError("Enter Id number");
        } else if (idProof.idProofFile === "") {
            setFileError("Please select a file");
        } else {
            setIdTypeError("");
            setIdNumberError("");
            setFileError("");
            dispatch(accountDetailsKYC(token, idProof, "IDENTITY"));
        }
    };

    const uploadAddressProof = () => {
        if (addressProof.type === "") {
            setAddressTypeError("Select any address proof");
        } else if (addressProof.idProofFile === "") {
            setAddressFileError("Please select a file");
        } else {
            setAddressTypeError("");
            setAddressFileError("");
            dispatch(accountDetailsKYC(token, addressProof, "ADDRESS"));
        }
    }

    return (
        <div className="SB-page-content">
            <div className="SB-myAccountSection-container SB-accountDetails">
                <div className="SB-pageHeader">
                    <div className="SB-pageHeader-title" id="memberProfile">Account details</div>
                </div>
                <div className="SB-content">
                    <div className="SB-myAccountSection SB-userDetails">
                        <div className="SB-myAccountSection-header">
                            Details
                        </div>
                        <div className="SB-myAccountSection-content">
                            <div className="SB-row">
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">First Name:</div>
                                        <div className="SB-form-control">
                                            <input id="accountFirstName" disabled={accountDetailsData?.firstName ? true : false} name="firstName" value={accountDetails.firstName} onChange={(e) => handleInput(e)} type="text" required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountFirstName">{firstNameError}</span></div>
                                    </div>
                                </div>
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Middle Name</div>
                                        <div className="SB-form-control">
                                            <input id="accountLastName" disabled={accountDetailsData?.surName ? true : false} name="middleName" value={accountDetails.middleName} type="text" onChange={(e) => handleInput(e)} required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountLastName">{middleNameError}</span></div>
                                    </div>
                                </div>
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Last Name</div>
                                        <div className="SB-form-control">
                                            <input id="accountLastName" disabled={accountDetailsData?.lastName ? true : false} type="text" name="lastName" value={accountDetails.lastName} onChange={(e) => handleInput(e)} required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountLastName">{lastNameError}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-row">
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Email*</div>
                                        <div className="SB-form-control">
                                            <input id="accountEmail" type="text" disabled={accountDetailsData?.userOtherInfo?.email ? true : false} name="email" value={accountDetails.email} onChange={(e) => handleInput(e)} required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountEmail">{EmailError}</span></div>
                                    </div>
                                </div>
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Mobile Number:</div>
                                        <div className="SB-form-control">
                                            <input id="accountmobileNumber" disabled={accountDetailsData?.userOtherInfo?.phone ? true : false} type="number" name="mobile" value={accountDetails.mobile} onChange={(e) => handleInput(e)} required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountmobileNumber">{mobileError}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-row">
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Date Of Birth:</div>
                                        <div className="SB-form-control">
                                            <input id="accountdob" type="date" required="" name="dateOfBirth" value={accountDetails.dateOfBirth} onChange={(e) => handleInput(e)} />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountdob">{dobError}</span></div>
                                    </div>
                                </div>
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Country:</div>
                                        <div className="SB-form-control">
                                            <input id="accountcountry" type="text" required="" name="country" value={accountDetails.country} onChange={(e) => handleInput(e)} />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountcountry">{countryError}</span></div>
                                    </div>
                                </div>
                            </div>

                            <div className="SB-row">
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">City:</div>
                                        <div className="SB-form-control">
                                            <input id="accountcity" onkeyup="btnDisable()" name="city" value={accountDetails.city} onChange={(e) => handleInput(e)} type="text" required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountcity">{cityError}</span></div>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-col">
                                                <div className="SB-form-group">
                                                    <div className="SB-form-control">
                                                        <input id="accountpasscode" onkeyup="btnDisable()" type="number" required="">
                                                            <div className="SB-form-label">PIN code:</div>
                                                    </div>
                                                    <div className="SB-form-errorMsg"><span id="erroraccountpasscode"></span></div>
                                                </div>
                                            </div> --> */}
                            </div>
                            <div className="SB-row">
                                <div className="SB-col">
                                    <div className="SB-form-group">
                                        <div className="SB-form-label">Address:</div>
                                        <div className="SB-form-control">
                                            <input id="accountaddress" onkeyup="btnDisable()" name="address" value={accountDetails.address} onChange={(e) => handleInput(e)} type="text" required="" />
                                        </div>
                                        <div className="SB-form-errorMsg"><span id="erroraccountaddress">{addressError}</span></div>
                                    </div>
                                </div>
                            </div>

                            <div className="SB-infoTxt">
                                <div className="SB-iconSVG">
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                        <use xlinkHref={`${icons}#icon-info`}></use>
                                    </svg>
                                </div>
                                <span> Please update your First Name, Middle Name, Last Name as per your Bank records</span>
                            </div>
                            {
                                detailsUpdatedSuccess ?
                                    <div className="SB-msgBox SB-success" id="userProfileDetailsSaved">
                                        <div className="SB-msgBox-container" id="userProfileDetailsError">
                                            Your details are updated successfully.
                                        </div>
                                    </div>
                                    :
                                    ""
                            }
                            <div className="SB-row">
                                <div className="SB-col text-center">
                                    <a id="userProfileDetailsBtn" >
                                        <button className="btn SB-btn SB-btnSecondary active SB-btnLarge w-auto w-100-mobile" onClick={handleUpdateDetails}>
                                            <span className="SB-btnTxt">Update Details</span>
                                            <div className="SB-loader d-none" id="profileloader">
                                                <div className="SB-dot-pulse"><span></span><span></span><span></span></div>
                                            </div>
                                        </button>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="SB-myAccountSection">
                        <div className="SB-myAccountSection-item SB-IDProof">
                            <div className="SB-myAccountSection-header">
                                <div>ID Proof</div>
                                <span className="SB-badge SB-success">Success</span>
                                <span className="SB-badge SB-pending d-none">Pending</span>
                                <span className="SB-badge SB-declined d-none">Declined</span>
                                <span className="SB-badge SB-submitted d-none">Submitted</span>
                            </div>
                            <div className="SB-myAccountSection-content">
                                <div className="SB-row align-items-top">
                                    <div className="SB-col">
                                        <div className="SB-form-group">
                                            <div className="SB-form-label">ID proof</div>
                                            <div className="SB-select">
                                                <select name="type" value={idProof.type} onChange={handleIdProof}>
                                                    <option value={""}>Select</option>
                                                    <option value={"Aadhar Card"}>Aadhar Card</option>
                                                    <option value={"Driving License"}>Driving License</option>
                                                    <option value={"Voter ID"}>Voter ID</option>
                                                </select>
                                            </div>
                                            <div className="SB-form-errorMsg">{idTypeError}</div>

                                        </div>
                                    </div>
                                    <div className="SB-col">
                                        <div className="SB-form-group">
                                            <div className="SB-form-label">ID Number:</div>
                                            <div className="SB-form-control">
                                                <input id="accountcity" name="idNumber" value={idProof.idNumber} onChange={handleIdProof} type="text" required="" />
                                            </div>
                                            <div className="SB-form-errorMsg"><span id="erroraccountcity">{idNumberError}</span></div>
                                        </div>
                                    </div>
                                    <div className="SB-col">
                                        <div className="SB-form-group SB-form-control-fileUpload">
                                            <div className="SB-form-label">Select a file for Id Proof:</div>
                                            <div className="SB-form-control">
                                                <input type="file" onChange={handleIdProof} accept="image/x-png,image/gif,image/jpeg" id="idProofFile" name="idProofFile" required="" />
                                            </div>
                                            <div className="SB-helpTxt">Max file size: 1.5MB; Supported file formats: .png, .jpeg, .jpg</div>
                                            <div className="SB-form-errorMsg" id="fileIdProofError">{fileError}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-msgBox d-none" id="userProfileDetailsSaved">
                                    <div className="SB-msgBox-container" id="userProfileDetailsError">
                                        Your details are updated successfully.
                                    </div>
                                </div>
                                <div className="SB-row">
                                    <div className="SB-col text-center">
                                        <a id="userProfileDetailsBtn" >
                                            <button className="btn SB-btn SB-btnSecondary active SB-btnLarge w-auto w-100-mobile" onClick={uploadIdProof}>
                                                <span className="SB-btnTxt ">Upload</span>
                                                <div className="SB-loader d-none" id="profileloader">
                                                    <div className="SB-dot-pulse"><span></span><span></span><span></span></div>
                                                </div>
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="SB-myAccountSection-item SB-addressProof">
                            <div className="SB-myAccountSection-header">
                                <div>Address Proof</div>
                                <span className="SB-badge SB-success d-none">Success</span>
                                <span className="SB-badge SB-pending">Pending</span>
                                <span className="SB-badge SB-declined d-none">Declined</span>
                                <span className="SB-badge SB-submitted d-none">Submitted</span>
                            </div>
                            <div className="SB-myAccountSection-content">
                                <div className="SB-row align-items-top">
                                    <div className="SB-col">
                                        <div className="SB-form-group">
                                            <div className="SB-form-label">Address proof</div>
                                            <div className="SB-select">
                                                <select name="type" value={addressProof.type} onChange={handleAddressProof}>
                                                    <option value={""}>Select</option>
                                                    <option value={"Aadhar Card"}>Aadhar Card</option>
                                                    <option value={"Driving License"}>Driving License</option>
                                                    <option value={"Voter ID"}>Voter ID</option>
                                                </select>
                                            </div>
                                            <div className="SB-form-errorMsg">{addressTypeError}</div>

                                        </div>
                                    </div>
                                    <div className="SB-col">
                                        <div className="SB-form-group SB-form-control-fileUpload">
                                            <div className="SB-form-label">Select a file for Address Proof:</div>
                                            <div className="SB-form-control">
                                                <input type="file" onChange={handleAddressProof} accept="image/x-png,image/gif,image/jpeg" id="idProofFile" name="idProofFile" required="" />
                                            </div>
                                            <div className="SB-helpTxt">Max file size: 1.5MB; Supported file formats: .png, .jpeg, .jpg</div>
                                            <div className="SB-form-errorMsg" id="fileIdProofError">{addressFileError}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-msgBox d-none" id="userProfileDetailsSaved">
                                    <div className="SB-msgBox-container" id="userProfileDetailsError">
                                        Your details are updated successfully.
                                    </div>
                                </div>
                                <div className="SB-row">
                                    <div className="SB-col text-center">
                                        <a id="userProfileDetailsBtn">
                                            <button className="btn SB-btn SB-btnSecondary active SB-btnLarge w-auto w-100-mobile" onClick={uploadAddressProof}>
                                                <span className="SB-btnTxt">Upload</span>
                                                <div className="SB-loader d-none1"> </div>
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AccountDetails;